export default __webpack_public_path__ + "static/media/carousel-5-min.528bf2c9.png";